import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { track } from "../../utils/analytics";
import "../../styles/GiftOutcome.css";
import "../../styles/buttons.css";

export default function GiftSuccessPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const planId       = params.get("plan")          || "unknown";
  const accountType  = params.get("account_type")  || "unknown";

  /* ───────── analytics ───────── */
  useEffect(() => {
    // GA4 page view
    track("page_view", {
      page_location: window.location.href,
      page_title   : "Gift Checkout Success",
    });

    // funnel completion
    track("gift_purchase_success", {
      plan_id     : planId,
      account_type: accountType,
    });

    // user-property for gifters
    window.gtag?.("set", "user_properties", { is_gifter: true });
  }, [planId, accountType]);

  /* helper for CTA links */
  const navClick = (label, dest) =>
    track("navigation_click", {
      location   : "gift_success",
      nav_item   : label,
      destination: dest,
    });

  return (
    <div className="gift-outcome-container">
      <Link to="/" className="gift-logo" onClick={() => navClick("Logo", "/")}>
        BestDay2Marry
      </Link>

      <div className="gift-message">
        <h1>Thank you! 🎉</h1>
        <p>Your gift was purchased successfully.</p>
        <p>The recipient will receive an email with a redeem link shortly.</p>
        <p>If you can’t find your receipt, please check your spam folder.</p>

        <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
          <Link
            to="/"
            className="btn btn-secondary"
            onClick={() => navClick("Go Home", "/")}
          >
            Go to Home
          </Link>
          <Link
            to="/pricing/couples"
            className="btn btn-primary"
            onClick={() => navClick("View Pricing", "/pricing/couples")}
          >
            View Pricing
          </Link>
        </div>
      </div>
    </div>
  );
}